import React from 'react';
import Button from '../Button';
import Icon from '../Icon';
import IncomeTrend from './IncomeTrend';
import { formatAccounting } from '../../domain/expenses';
import { basisNote } from '../../domain/expenseForms';
import { useMoneyFormat } from '../../context/LocaleContext';
import { figureOrDash } from '../../domain/reading';
import s from './SummaryPanel.module.css';


// The month's four numbers. Presentational: it is handed a summary and prints
// it, and knows nothing about how the figures were folded. `read` is false
// while what they are folded from is unread (#629): each is the dash.
export function SummaryCard({ summary, basis, read = true }) {
  const formatMoney = useMoneyFormat();
  const money = (minor) => figureOrDash(read, formatMoney(minor));
  return (
    <div className={s.card}>
      <div className={s.row}><span>Teaching</span><span>{money(summary.teachingMinor)}</span></div>
      <div className={s.row}><span>Other Revenue</span><span>{money(summary.otherRevenueMinor)}</span></div>
      <div className={s.row}><span>Expenses</span><span>{money(summary.expensesMinor)}</span></div>
      <div className={s.net}>
        <span>Net Income</span>
        <span>{figureOrDash(read, formatAccounting(summary.netIncomeMinor, formatMoney))}</span>
      </div>
      <div className={s.basisNote}>{basisNote(basis)}</div>
    </div>
  );
}

export function SummaryToggle({ shown, onToggle }) {
  return (
    <div className={s.divider}>
      <div className={s.dividerLine} />
      <span className={s.dividerButton}>
        <Button variant="secondary" onClick={onToggle}>
          <span className={s.toggleLabel}>
            {shown ? 'Hide Summary' : 'Show Summary'}
            <Icon name={shown ? 'eyeOff' : 'eye'} />
          </span>
        </Button>
      </span>
    </div>
  );
}

export default function SummaryPanel({ summary, series, basis, read = true }) {
  return (
    <div className={s.grid}>
      <SummaryCard summary={summary} basis={basis} read={read} />
      <IncomeTrend series={series} read={read} />
    </div>
  );
}
